<template>
  <div class="modal" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header p-3">
          <h6 class="modal-title">{{$t('Add Field(s)')}}</h6>
          <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close" @click="close()">
            <span aria-hidden="true"><close-icon class="close-icon" style="height: 30px !important;
    width: 30px !important;
    color: #fff;"></close-icon></span>
          </button>
        </div>
        <div class="modal-body">
                 <multiselect
                        id="folderNameField"
                        v-model="userTypes" 
                        :options="userTypesOptions"
                        track-by="_id"
                        :custom-label="userTypeLabelCallback"
                        :close-on-select="true"
                        :multiple="browseMultiFields"
                        :show-no-results="false"
                        deselectLabel =""
                        selectLabel=""
                        selectedLabel=""
                        :placeholder="$t('Enter field name')"
                        :hideSelected="false"
                        :showNoOptions="false"
                        @open="getFieldsFromServer"
                        @search-change="getusersOnKeyup($event)"
                        @select="userTypeOnSelect($event)"
                        @remove="userTypeOnRemove($event)"
                        style="margin-top: 7px;">
                        <span slot="noResult">No results</span>
                        <span slot="noOptions" style="display:none"></span>
                        <div slot="tag" slot-scope="option" class="selected-tags-style">
                        <div class="tags-display-style">{{option.option.name}}</div>
                            <div class="remove-tag" v-on:click="removeSelectedOption(option.option)">
                                <svg width="2em" height="1.5em" viewBox="0 0 16 16" class="bi bi-x" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                                </svg>
                            </div>
                        </div>
                        <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                        <input type="checkbox" class="rounded text-light mr-3 bigger-checkboxes" :checked="makeCheckBoxSelection(scope.option)" @focus.prevent :key="scope.option.name"/>
                        <span style="margin-inline-start:12px;">{{ scope.option.name }}</span>
                        </div>
                    </multiselect>
              </div>
        <div class="modal-footer p-0 primary-btn-style">
          <button class="btn btn-outline-secondary mr-3" data-dismiss="modal" @click="close()">{{$t('Cancel')}}</button>
          <button class="btn btn-outline-primary mr-2" @click.prevent="updateUserGroup()">{{$t('Add')}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import multiselect from 'vue-multiselect';
import {NotifierConstants} from "../../components.constants.js";
import {mapGetters, mapMutations, mapActions} from "vuex";
import Utils from "../../components.utils.js";
import closeIcon from "../core/InlineCancelField.vue";

export default {
props:["selectedUserGroupID","selectedIds","isEditGroup","browseMultiFields","isScreenProfile", "screenType"],
  data: () => ({
    dialog: true,
    userTypes: [],
    userTypesOptions: [],
    selectedUserIdNameMap:{},
    postData: {},
    show:false
  }),
  components:{
    "multiselect":multiselect,
    "close-icon":closeIcon
  },
  methods:{
    close(){
        this.$emit('close')
    },
    style(name){
        let style = {
        'color':Utils.textColor(Utils.intToRGB(Utils.hashCode(name))),
        'background-color':'#'+Utils.intToRGB(Utils.hashCode(name))
        }
        return style
    },
    userTypeLabelCallback(option){
      return `${option.name}`
    },
    getCustomMetadataName(fieldInfo){
      if('language_alias_mapper' in fieldInfo && fieldInfo.language_alias_mapper && fieldInfo.language_alias_mapper.length > 0 && this.$i18n && this.$i18n.locale){
        let mapperExists = fieldInfo.language_alias_mapper.find(op=>op.code == this.$i18n.locale)
        if(mapperExists && Object.keys(mapperExists).length > 0 && mapperExists.field_alias && mapperExists.field_alias.length > 0){
          return mapperExists.field_alias;
        }
      }
      return fieldInfo.name;
    },
    userTypeOnSelect(option){
      let idNameMapper = this.selectedUserIdNameMap;
      idNameMapper[option._id] = this.getCustomMetadataName(option);
      Object.assign(this.selectedUserIdNameMap, this.idNameMapper);
      // this.selectedUserIdNameMap[option._id] = option.name;
      let index = this.userTypesOptions.findIndex(item => item._id == option._id);
        if(index > -1){
            this.userTypesOptions[index].checked = true; 
        }
    },
    userTypeOnRemove(option){
      let index = this.userTypesOptions.findIndex(item => item._id == option._id);
      if(index > -1){
          this.userTypesOptions[index].checked = false; 
          this.userTypes = this.userTypes.filter(e => e._id != this.userTypesOptions[index]._id);
      }
    },
    removeSelectedOption(option){
      this.userTypeOnRemove(option)
    },
    getDefaultFields(){
      if(this.screenType && this.screenType == "ScreenProfiles"){
        return [{"_id":"Description", "name":"Description"},
                {"_id":"Catalogs","name":"Catalogs"}]
      }
      return []
    },
    getFieldsFromServer(){
      let payload = {}
      this.getAllCustomMetadataFromServer(payload).then((data)=>{
        let fieldList = this.getDefaultFields();
        fieldList = fieldList.concat(data.custom_metadatas)
        for(let eachField of fieldList){
          eachField['name'] = this.getCustomMetadataName(eachField)
        }
        // this.userTypesOptions = fieldList;
        this.userTypesOptions = fieldList.filter((cmMetadata)=>(!('load_when' in cmMetadata) || ('load_when' in cmMetadata && cmMetadata.load_when.length == 0)))
      });
    },
    getusersOnKeyup(option){
      if(typeof(option) != "undefined" && option.trim().length > 0){
        this.removeAlreadySelectedUsers(this.filteredUserGroups())
      }else if(option.length==0){
          this.removeAlreadySelectedUsers(this.usersList);
      }
    },
    filteredUserGroups(){
      if(this.search != null){
        if (!this.usersList.length) {
            return [];
          }
          return this.usersList.filter((item) => {
            const userGroupName = item.name.toLowerCase();
            const searchTerm = this.search.toLowerCase();
            return userGroupName.includes(searchTerm);
          });
        }else{
          return this.usersList;
      }
    },
     makeCheckBoxSelection(option){
        return this.userTypes.some((op) => op._id === option._id);
    },
    removeAlreadySelectedUsers(usersList){
        let usersInGroup = usersList;
        if(this.selectedIds != undefined && this.selectedIds.length){
            for(let j = 0; j < this.selectedIds.length; j++){
                let temp = this.selectedIds[j];
                    usersInGroup =  usersInGroup.filter(function(el){
                    return el._id != temp;
                });
            }
            this.userTypesOptions =  usersInGroup;
        }else{
            this.userTypesOptions = usersInGroup;
        }
        //below filter is given for remove child field from dropdown list
        this.userTypesOptions = this.userTypesOptions.filter((cmMetadata)=> (!('load_when' in cmMetadata) || ('load_when' in cmMetadata && cmMetadata.load_when.length == 0)))
    },
    updateUserGroup() {
      if(this.isEditGroup){
          let payload = {};
          if(this.userTypes.length > 0){
              for(let i=0; i<this.userTypes.length; i++){
                  this.selectedIds.push(this.userTypes[i]._id)
                  payload['user_list'] = this.selectedIds;
              }
          }
          payload.params = { _id: this.selectedUserGroupID };
          this.updateExistingUserGroup(payload).then((data) => {
              if (Utils.isAcceptedStatusCode(data.statusCode)) {
              if (data.message.includes("Failed")) {
                  this.$toast.warning(data.message);
              } else {
                  this.$toast.success(data.message);
                  this.close();
              }
              } else {
              this.$toast.error(data.message);
              }
          });
        this.close()
      }else{
          let temp = []
          if(this.browseMultiFields){
            if(this.userTypes.length > 0){
                for(let i=0; i<this.userTypes.length; i++){
                    temp.push(this.userTypes[i]._id)
                }
            }
          }else{
            if(typeof this.userTypes != "undefined"){
              temp = [this.userTypes._id];
            }
          }
          if(typeof(temp) == "undefined"){
              this.$emit('close',[],this.selectedUserIdNameMap)
              return
            }
            this.$emit('close', temp,this.selectedUserIdNameMap)
      }      
    },
    reloadFieldsInfo(){
      this.usersList = [];
      if(Object.keys(this.getStartUpDataFromInCache()).includes("custom_metadatas")){
          Object.assign(this.usersList,this.getStartUpDataFromInCache()["custom_metadatas"]);
      }
      let defaultFields = this.getDefaultFields()
      this.usersList = [...defaultFields, ...this.usersList];
      if(this.isScreenProfile){
        let tagInfoList=this.usersList.filter(t=>t._id==1);
        if(tagInfoList.length <= 0){
          this.usersList.push({
            "_id":"1",
            "name":"Tags"
          })
        }
      }
    },
    handleNotification(notification){
      notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
      if(notification.message){
        if([NotifierConstants.fieldCreatedNotification,
            NotifierConstants.fieldModifiedNotification,
            NotifierConstants.fieldRemovedNotification].includes(notification.message_type)){
              let entry_info = notification.message;
              if(NotifierConstants.fileRemovedNotification == notification.message_type){
                if(this.browseMultiFields){
                  this.userTypes = this.userTypes.filter(item=>item._id == entry_info.custom_metadata_id);
                }else if(this.userTypes._id == entry_info.custom_metadata_id){
                  this.userTypes._id = "";
                }
              }
              setTimeout(()=>{
                this.reloadFieldsInfo();
              }, 100);
        }
      }
    },
    ...mapGetters("startUpData",["getStartUpDataFromInCache"]),
    ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener"]),
    ...mapActions("customMetadata", ["getAllCustomMetadataFromServer"]),
  },
  watch: {
    'show': function (val) {
      if (val) {
          this.$nextTick(() => {
          document.getElementById("folderNameField").focus();
          this.userTypesOptions = [];
        })
      }
    }
  },
  created(){
    this.reloadFieldsInfo();
    this.addWSEventListener({
            eventname:[NotifierConstants.fieldCreatedNotification,
            NotifierConstants.fieldModifiedNotification,
            NotifierConstants.fieldRemovedNotification],
            callback:this.handleNotification,
            parent:"AddFieldsFromBrowser"})
  },
  beforeDestroy(){
    this.removeWSEventListener({
            eventname:[NotifierConstants.fieldCreatedNotification,
            NotifierConstants.fieldModifiedNotification,
            NotifierConstants.fieldRemovedNotification],
            callback:this.handleNotification,
            parent:"AddFieldsFromBrowser"})
  },
  mounted(){
    setTimeout(() => {
      this.show = true;
    }, 200)
  },
}
</script>

<style lang="scss" scoped>
  $table-row-border: none;
$active-blue: #007bff;
$danger-color: #dc3545;
$none-text-color:#4f4f4f;
$add-button-text-color:#0b7099;
$add-button-text-color-hover:#0193cc;
$add-button-border-color:#b7b228;
$add-button-border-on-hover:#dcd426;
$add-button-backgroud:#1e1e1e;
$active-green-color:#28a745;
$primary-background: #1a1e21;
$border-color: 1px solid #4a4a4a;
$primary-background: #1a1e21;
$secondary-background-color:#15181B;
$bg-color-on-hover: #22272b;
$text-color: #eee;
$dull-text-color: #757575;
$secondary-text-color: #9c9c9c;
$active-blue : #007bff;
$input-field-and-label-font-size:14px;
$input-field-height:38px;
$highlight-font-color:#ff9800;
$scrollbar-thumb-background:#333;
$scrollbar-track-background:#1a1e21;
$scrollbar-thumb-on-hover-background:#555; 
$input-field-padding:.375rem 10px;
$filter-border-color: #5a5a5a;
$filter-bg-color: #2a2a2a;
$learn-about-text-color-hover:#b7b327;
$learn-about-text-color:#9a9620;
$tags-background-color:#282d31;
$svg-color:#666;
$tags-border-color:#363636;
$secondary-border-color: 1px solid #2b2b2b;
$icon-hover:#2c3339;

.modal-dialog {
    max-width: 600px;
    width: 600px;
    margin: 0;
    padding: 0;
  }

  .modal{
    transition: opacity .3s ease;
  }

  
  .modal-content {
    height: auto;
    min-height: 100%;
    border: 0 none;
    border-radius: 0;
    box-shadow: none;
    background: $primary-background !important;
    border: $secondary-border-color;
    .modal-body{
      background: $primary-background;
      padding: 2rem;
    }
  }

.modal {
    text-align: center;
    padding: 0 !important;
    display: block;
    position: fixed;
    inset-inline-start: 0px;
    top: 30% !important;
}
.modal-header .close {
    margin: 0px !important;
    padding: 0px !important;
}
.modal:before {
  content: '';
    display: inline-block;
    height: 100vh;
    vertical-align: middle;
    margin-inline-end: -4px;
    position: fixed;
    width: 100vw;
    inset-inline-start: 0;
    top: 0;
    background: #00000094;
}
.modal-dialog {
  display: inline-block;
  text-align: start;
  vertical-align: middle;
}

.btn{
    font-size:$input-field-and-label-font-size !important;
    height:100%;
}

.border{
    border: $border-color !important;
}

.modal-header,.modal-footer{
    border-top: $secondary-border-color !important;
    border-bottom: $secondary-border-color !important;
    background: $secondary-background-color;
    height: 58px;
    align-items: center;
    .modal-title{
      color:$text-color;
    }
}

.primary-btn-style{
    button{
        height: 35px;
        width: 70px;
        font-size:$input-field-and-label-font-size;
    }
}

.secondary-btn-style{
  color:$text-color;
}

.key-style {
  color: $dull-text-color;
  width: 30%;
  text-align: start;
  font-size: $input-field-and-label-font-size;
  padding-inline-start: 5px;
  padding-inline-end: 5px;
  margin-top: 3px;
}

.close-icon:hover{
  background: $icon-hover;
  border-radius: 20px;
}

.bigger-checkboxes {
    height: 30px;
    width: 20px;
    position:relative;
}
input[type="checkbox"]:after {
    line-height: 1.5em;
    content: "";
    display: inline-block !important;
    width: 22px !important;
    height: 21px !important;
    margin-top: 5px !important;
    margin-inline-start: -1px !important;
    border: $border-color !important;
    border-radius: 0.25em !important;
    background: $primary-background !important;
}
input[type="checkbox"]:checked:after {
    content: "✔";
    color: $active-blue !important;
    position: absolute !important;
    font-size: 16px !important;
    line-height: 1 !important;
    transition: all 0.2s !important;
    font-family: Helvetica, Arial, sans-serif;
    padding-inline-start: 4px !important;
    padding-top: 2px !important;
}

.user-name-or-image{
    height: 30px;
    width: 30px;
    border: $border-color;
    border-radius: 10px;
    text-align: center;
    line-height: 28px;
    text-transform: uppercase;
    margin-top: 3px;
}

.tags-style{
    display: flex;
    height: fit-content;
    padding: 5px;
    width: auto;
    border-radius: 11px;
    margin-inline-end:0px 5px;
    .user-name-display{
        line-height: 33px;
        padding-inline-start: 5px;
    }
    .remove-tag{
        line-height: 32px;
        position: relative;
        inset-inline-start: 5px;
        svg{
            height:30px !important;
        }
    }
}

   ::v-deep{
    .add-search-filter{
        display: inline-flex;
        border: 1px solid #0779fb !important;
        color: #0779fb !important;
        .add-fileds-icon{
            position: absolute;
            inset-inline-start: 10px;
            z-index: 99;
            top: 13px;
        }
        .multiselect{
            min-width:15%;
            margin: -2px 0px;
            .multiselect__tag{
                display:none;
            }
            .multiselect__select{
                display:none;
            }
        }
    }
    .multiselect{
            width:100%;
            margin: 3px 0px;
    }
    .multiselect__content-wrapper{
        display:none;
    }
    .multiselect__tag, .tags-style {
        background-color: $primary-background !important;
        border: $border-color;
        border-radius: 5px;
        margin-bottom:0px;
    }
    .multiselect__tags, .tags-style {
        background: $primary-background !important;
        border: $border-color !important;
    }
        .multiselect__option--highlight {
            background: $bg-color-on-hover !important;
        }
        .multiselect__content {
            background: $secondary-background-color !important;
        }
        .multiselect__input, .multiselect__single {
            background: transparent !important;
            color:$text-color;
        }
        .multiselect__input:focus{
            outline:none;
            box-shadow: none;
        }
        .multiselect__tag-icon{
        color:$text-color;
        }
        .multiselect__tag-icon:focus, .multiselect__tag-icon:hover {
            background: $bg-color-on-hover !important;
            color: $text-color !important;
        }
        .multiselect__tag-icon:after{
        color:$secondary-text-color !important;
        font-size: 20px;
        }
        .multiselect *{
            font-size: $input-field-and-label-font-size;
            font-family: "Roboto", Arial, sans-serif !important;
        }
        .multiselect__tags{
            display: block;
            align-items: center;
        }
        .multiselect__placeholder {
            padding-top: 5px !important;
            margin-bottom:0px;
            color:#5d5d5d !important;
        }
        .multiselect{
            color:$text-color !important;
            font-size: $input-field-and-label-font-size !important;
            min-height: 38px;
        }
        .multiselect__single{
            padding-top:6px !important;
        }
        .multiselect__option--selected{
            background: $bg-color-on-hover !important;
            color: $text-color;
        }
        .multiselect__content-wrapper{
            border: 1px solid $bg-color-on-hover !important;
            position: absolute;
            display: block;
            background: $text-color;
            width: 100%;
            max-height: 150px;
            overflow: auto;
            border: 1px solid $text-color;
            border-top: none;
            border-bottom-left-radius: 5px;
            border-bottom-right-radius: 5px;
            z-index: 50;
            -webkit-overflow-scrolling: touch;
        }
        .multiselect__select,.multiselect__current,.multiselect__option{
            line-height: 12px !important;
        }
        .multiselect--above .multiselect__content-wrapper{
        background: $secondary-background-color !important;
        }
        .multiselect__tags {
            background: $primary-background!important;
            height: auto;
        }
        .filter-wrapper{
            display:inline-flex;
            align-items: center;
            border: $border-color;
            border-radius: 5px;
            background: $primary-background;
            color:$dull-text-color;
            .filter-label{
                margin:0px 4px;
                width: auto;
                white-space: nowrap;
            }
            .comm-input-field-style,.multiselect__tags{
                border: none !important;
                border-radius: none !important;
            }
            .mx-input{
                height:38px;
            }
            .multiselect{
                margin:0px !important;
            }
        }
    }

.selected-tags-style{
  background: $tags-background-color;
  border: 1px solid $tags-border-color;
  border-radius: 15px;
  font-size: 12px !important;
  min-height: 30px !important;
  display: inline-flex !important;
  margin: 2px !important;
  border-radius: 15px !important;
  min-width: 50px !important;
  padding: 0px !important;
  text-align: center;
  width: auto !important;
  padding-inline-start: 12px !important;
  justify-content: center;
  padding-top: 4px !important;
  padding-inline-end: 4px !important;
  .remove-tag{
    line-height:18px;
  }
}

</style>